
const labelsToAccessMap = (labelList) => {
  return labelList.reduce((acc, it) => (acc[it.value] = it.label, acc), {});
};

export const validationCancelMotive = [
  {value: 'job', label: 'Emprego'},
  {value: 'suppliers', label: 'Fornecedores'},
  {value: 'repeated', label: 'Repetido'},
  {value: 'relatives', label: 'Familiares'},
  {value: 'mistake', label: 'Engano'},
  {value: 'solved', label: 'Resolvido'},
  {value: 'other_valence', label: 'Outra Valência'},
  {value: 'professionals', label: 'Profissionais'},
  {value: 'internship', label: 'Estágio'},
  {value: 'firemen', label: 'Bombeiros'},
  {value: 'mortuary', label: 'Funerária'},
  {value: 'police', label: 'Polícia'},
  {value: 'volunteering', label: 'Voluntariado'},
  {value: 'member_subscriber', label: 'Sócios/Inscritos'},
  {value: 'no_help', label: 'Não quer ajuda'},
  {value: 'no_decision_maker', label: 'Não é o decisor'},
  {value: 'future_application', label: 'Incrição p/ futuro'},
  {value: 'IPSS_only', label: 'Só quer IPSS'},
  {value: 'potential_client', label: 'Potencial cliente'},
  {value: 'customer', label: 'Cliente'},
  {value: 'prices_only', label: 'Só quer preços'},
  {value: 'death', label: 'Falecimento'},
  {value: 'other', label: 'Outro'},
  {value: 'other_way', label: 'Encontrou lar por outra via'},
  {value: 'death', label: 'Idoso(a) faleceu'},
  {value: 'care_taker', label: 'Colocação de cuidador em casa'},
  {value: 'home_support', label: 'Optou com Apoio Domiciliário'},
  {value: 'day_center', label: 'Optou com Centro de Dia'},
  {value: 'IPPS', label: 'Chamado(a) para IPSS'},
  {value: 'cc', label: 'Chamado(a) para CC'},
  {value: 'hospital', label: 'Internamento, estado crítico'},
  {value: 'other', label: 'Outro'},
  {value: 'client_requested', label: 'A pedido do emissor'},
];

export const REQUEST_PERIODS = [
  {value: 1, label: "Hoje ou Dentro de Dias"},
  {value: 2, label: "Este mês ou no Próximo"},
  {value: 3, label: "Não sei"}
];

export const cancelMotiveMap = labelsToAccessMap(validationCancelMotive);

export const requestPeriodsMap = labelsToAccessMap(REQUEST_PERIODS);
